import { render, staticRenderFns } from "./Heat.vue?vue&type=template&id=2fb38604&"
import script from "./Heat.vue?vue&type=script&lang=js&"
export * from "./Heat.vue?vue&type=script&lang=js&"
import style0 from "./Heat.vue?vue&type=style&index=0&id=2fb38604&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports